import * as React from 'react'
import { BaseIconProps } from '../../../types'

function SvgQq({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.534 16.703a6.262 6.262 0 01-1.695 3.276c.943.423 1.794 1.068 1.794 2.021H5.369c0-.953.853-1.595 1.794-2.02a6.246 6.246 0 01-1.694-3.277C4.472 18.118 3 18.819 3 18.819c0-3.67 2.37-8.637 2.37-8.637V8.364C5.37 4.849 8.34 2 12 2c3.664 0 6.632 2.849 6.632 6.364v1.817S21 15.148 21 18.818c.002 0-1.473-.7-2.466-2.115z"
        fill={color}
      />
    </svg>
  )
}

export default SvgQq
